import Bus from '@/bus/BusEvent.js'
import Store from '@/stores/store.js'
import Raf from '@/utils/raf.js'
import invertPass from '@/views/GL/invertPass.js'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';

class GL {
    constructor(el) {
        this.$el = null;
        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2(Infinity, Infinity);
        this.touch = new THREE.Vector2(Infinity, Infinity);
        this.scene = null;
        this.camera = null;
        this.renderer = null;
        this.nbrTransitionLoaded = 0;

        this.isHovered = false;


        this._onMouseMove = this.onMouseMove.bind(this);
        this._update = this.update.bind(this);
        this._updateMouse = this.updateMouse.bind(this);

        this.hoverableOjbect = [];
        this.hoverableGroup = [];
    }

    init(el) {
        this.$el = el;

        this.camera = new THREE.OrthographicCamera();
        this.camera.position.z = 110;
        this.scene = new THREE.Scene();

        this.renderer = new THREE.WebGLRenderer({
            canvas: this.$el,
            scene: this.scene,
            antialias: false
        });
    

        this.composer = new EffectComposer(this.renderer);
        this.renderPass = new RenderPass(this.scene, this.camera);
        this.composer.addPass(this.renderPass);
        
        this.invertPass = new ShaderPass(invertPass);
        this.invertPass.uniforms['u_resolution'].value = new THREE.Vector2(this.renderer.getContext().drawingBufferWidth, this.renderer.getContext().drawingBufferHeight);
        this.invertPass.uniforms['invert_progress'].value = 0.0;
        this.composer.addPass(this.invertPass);

        this.onResize();

        this.setEvents()

        window.addEventListener('mousemove', this._onMouseMove, false);
        this._onResize = this.onResize.bind(this);
        
        Bus.$on('resize', this._onResize);
        Raf.add(this._update);
    }

    setInvertColor(val){
        this.invertPass.uniforms['invert_progress'].value = val;
    }

    onResize(){
        this.camera.left = Store.width / -2;
        this.camera.right = Store.width / 2;
        this.camera.top = Store.height / -2;
        this.camera.bottom = Store.height / 2;
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(Store.width, Store.height);
        this.camera.updateProjectionMatrix();
        this.composer.setPixelRatio(window.devicePixelRatio);
        this.composer.setSize(Store.width, Store.height);
        this.invertPass.uniforms['u_resolution'].value = new THREE.Vector2(this.renderer.getContext().drawingBufferWidth, this.renderer.getContext().drawingBufferHeight);
    }

    addTextGL(textGL){
        this.addHoverableOjbect(textGL);
    }

    addHoverableOjbect(obj){
        this.hoverableOjbect.push(obj);
    }

    addHoverableGroup(obj){
        this.hoverableGroup.push(obj);
    }

    addGroupGL(group){
        this.scene.add(group);
    }

    onMouseMove(event) {
        Raf.addOnce( function(){
            this._updateMouse(event);
        }.bind(this));
    }

    updateMouse(event) {
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
    }

    updateTouch(touches) {
        this.touch.x = (touches.clientX / window.innerWidth) * 2 - 1;
        this.touch.y = - (touches.clientY / window.innerHeight) * 2 + 1;
    }

    detectHoverOnGroup() {
        for (let index = 0; index < this.hoverableGroup.length; index++) {
            if (this.raycaster.intersectObject(this.hoverableGroup[index], true).length > 0) {
                this.hoverableGroup[index].mouseEnter()
                
            } else {
                this.hoverableGroup[index].mouseLeave()
            }            
        }
    }

    mobileRaycaster() {
        this.raycaster.setFromCamera(this.touch, this.camera);
        this.detectHoverOnGroup()
    }

    cursorBack(exeption) {
        if(this.raycaster.intersectObjects(this.hoverableGroup, true).length > 0) this.isHovered = true
        else this.isHovered = false 
        
        
        if(!this.isHovered && Store.state.level > 0 && !Store.state.isHovering) Store.state.cursorText = 'Back'
        else if(!this.isHovered && Store.state.level == 0) Store.state.cursorText = ''
    }

    update() {
        // //RAYCASTER
        this.raycaster.setFromCamera(this.mouse, this.camera);

        //HOVER
        if(!Store.isMobile) this.detectHoverOnGroup()

        // CURSOR 
        this.cursorBack()
        
        this.composer.render();
        // this.renderer.render(this.scene, this.camera);
    }

    setEvents() {

        window.addEventListener('touchend', ()=>{
            this.mobileRaycaster()
        })

        window.addEventListener('touchstart', (_e)=>{
            this.updateTouch(_e.touches[0])
        })

        window.addEventListener('touchmove', (_e)=>{
            this.updateTouch(_e.touches[0])
        })
    }

    removeEvents() {
    }

}

let GLInstance = new GL();

export default GLInstance;